export const BASE_TOOL_COMMON_PROPS = {
  id: undefined,
  name: undefined,
  originalParameters: [],
  maximumDuration: undefined,
  advancedParametersCollapsed: true,
  configVersion: undefined,
};
